import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { categoryService } from '../../services/categoryService';

const categories = [
  { name: 'iPhone', icon: '📱', color: 'from-gray-700 to-gray-900', image: 'https://images.unsplash.com/photo-1592899677977-9e10cb588e3e?w=300' },
  { name: 'Samsung', icon: '📲', color: 'from-blue-600 to-blue-800', image: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=300' },
  { name: 'Xiaomi', icon: '📱', color: 'from-orange-500 to-orange-700', image: 'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=300' },
  { name: 'OnePlus', icon: '⚡', color: 'from-red-600 to-red-800', image: 'https://images.unsplash.com/photo-1616348436168-de43ad0db179?w=300' },
  { name: 'Google Pixel', icon: '🔵', color: 'from-blue-500 to-blue-700', image: 'https://images.unsplash.com/photo-1592899677977-9e10cb588e3e?w=300' },
  { name: 'Oppo', icon: '📱', color: 'from-green-600 to-green-800', image: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=300' },
  { name: 'Vivo', icon: '📱', color: 'from-purple-600 to-purple-800', image: 'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=300' },
  { name: 'Infinix', icon: '📱', color: 'from-teal-600 to-teal-800', image: 'https://images.unsplash.com/photo-1616348436168-de43ad0db179?w=300' },
];

const CategoriesShowcase = () => {
  const [dbCategories, setDbCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await categoryService.getCategories();
        setDbCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  const displayCategories = dbCategories.length > 0 ? dbCategories.slice(0, 8) : categories;

  return (
    <section className="py-20 categories-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="section-title">Shop by Category</h2>
          <p className="section-subtitle">Browse our collection by brand and find your perfect device</p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4">
          {displayCategories.map((category, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
            >
              <Link
                to={`/products?brand=${category.name}`}
                className="block group"
              >
                <div className={`bg-gradient-to-br ${category.color || 'from-primary-600 to-primary-800'} rounded-2xl p-4 text-center transform transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl`}>
                  <div className="text-4xl mb-2">{category.icon || '📱'}</div>
                  <h3 className="text-white font-semibold text-sm">{category.name}</h3>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesShowcase;